module.exports = __webpack_public_path__ + "img/bicycleUnit.72cf5521.png";